import { DeleteOutline, DownloadOutlined } from "@mui/icons-material";
import {
  Table, message, Dropdown,
  Upload,
  Menu,
  Input,
  Modal,
  Select,
  Button,
  Radio,
  Form,
  notification,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { getUserList, getUserInfo, getClientid } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { toggleProcessingModal } from "redux/actions";
import download from "downloadjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import styled from "@emotion/styled";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";


const CVContainer = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const CVHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h6 {
    margin: 0;
    font-weight: 600;
    color: #111827;
  }
`;

const TableWrapper = styled.div`
  flex: 1;
  min-height: 300px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;

  overflow-x: auto;   /* horizontal scroll here */
  overflow-y: hidden;

  display: flex;
  flex-direction: column;
`;

// PERMISSION FIX: used when the parent does not pass a `permission` prop
// (e.g. this widget rendered somewhere other than the dashboard).
const DEFAULT_PERMISSION = { view: true, create: true, edit: true, delete: true };

const MyCV = ({
  userInfo,
  userList,
  ClientId,
  updateProcessingModal,
  selectedItem,
  permission = DEFAULT_PERMISSION,
}) => {
  // PERMISSION FIX: "+ Add New" needs create, the delete icon needs delete.
  // Download stays available with view access.
  const canCreate = permission?.create === true;
  const canDelete = permission?.delete === true;

  const [filteruser, setFilterUser] = useState({});
  const [isDocumentUpload, setIsDocumentupload] = useState(false);
  const [docLoader, setDocLoader] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewURL, setPreviewURL] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileDetails, setFileDetails] = useState("");
  const [cvType, setCvType] = useState("long"); // default Long Form
  const [fileType, setFileType] = useState(undefined);
  const [fileList, setFileList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    const filteredUser =
      userList?.filter((item) => item?.userid === userInfo?.userid)[0];

    setFilterUser(filteredUser);


  }, [userList, userInfo]);

  const { key: myCVKey, url: myCVUrl } = queryKeys.getMyCV(
    `?clientid=${ClientId}&userid=${filteruser?.userid}`
  );

  const { data: myCVRes, refetch: refetchMyCV } = useFetch(myCVKey, myCVUrl, {
    enabled: !!ClientId && !!filteruser?.userid,
  });

  const cvList = myCVRes?.response?.cv || [];

  const getFormattedDateTime = () => {
    const now = new Date();

    const createdOn = now.toISOString().split("T")[0];
    // "2024-04-17"

    const createdTime = now.toTimeString().split(" ")[0];
    // "14:11:07"

    return { createdOn, createdTime };
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFileDetails("");
    setFileType(""); // reset file type
    setCvType(""); // reset CV type
    setFileList([]);
  };
  const filteredDataSource = (
    selectedItem && filteruser[selectedItem.value]
      ? filteruser[selectedItem.value]
      : []
  )?.filter((item) => {
    const search = searchTerm?.toLowerCase() || "";

    return (
      item?.documentName?.toLowerCase()?.includes(search) ||
      item?.name?.toLowerCase()?.includes(search)
    );
  });

  let updatedDataSource = filteredDataSource?.map((item) => {
    if (item.documentName) {
      const { documentName, ...rest } = item;
      return { ...rest, name: documentName, documentName: documentName };
    }
    return item;
  });

  const handleupload = async () => {
    if (!canCreate) return; // PERMISSION FIX

    const isDuplicate = updatedDataSource.some(
      (item) => item.cvtype === cvType && item.filetype === fileType
    );

    if (isDuplicate || !cvType || !fileType) {
      notification.error({
        message: "Duplicate File Detected",
        description: `A file with type "${fileType}" and CV type "${cvType}" already exists.`,
      });
      setFileDetails("");
      return;
    }

    updateProcessingModal(true);
    const res = await CALL_API(
      `upload-identity/${ClientId}/${filteruser?.userid}?endpoint=peopledocuments`,
      "post",
      {
        filename: fileDetails.name,
      }
    );
    const { createdOn, createdTime } = getFormattedDateTime();
    if (res?.url) {
      const putRes = await fetch(res.url, {
        method: "PUT",
        headers: {
          "Content-Type": fileDetails.type || "application/octet-stream",
        },
        body: fileDetails.filevalues,
      });
      if (putRes.ok) {
        const { code } = await CALL_API(
          `upload-identity/${ClientId}/${filteruser?.userid}`,
          "post",
          {
            name: fileDetails.name,
            type: fileDetails.type,
            objectKey: res?.key || "",
            documentName: "cv",
            fileSize: fileDetails?.fileSize,
            filetype: fileType,
            cvtype: cvType,
            createdOn: createdOn,
            createdTime: createdTime,
          }
        );
        if (code === STATUS_CODE.SUCCESS) {
          await refetchMyCV();
          message.success("Document uploaded");
          handleCloseModal();
        } else {
          message.error("You can only upload files up to 10MB in size.");
        }
      } else {
        console.error("Failed to upload to S3", putRes.statusText);
        message.error({ message: "File upload failed" });
        return;
      }
    }
    setFileDetails("");
    updateProcessingModal(false);
    setIsDocumentupload(false);
  };

  const deleteIdentityInfo = async (id, type) => {
    if (!canDelete) return; // PERMISSION FIX

    setDeletingId(id);
    setIsDeleteLoading(true);
    const { code } = await CALL_API(
      `upload-document/${ClientId}/${id}`,
      "delete",
      {
        documentName: type,
        userId: filteruser?.userid,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      await refetchMyCV();
      message.success("Document has been Deleted");
    }
    setIsDeleteLoading(false);
  };

  const handleMenuClick = async (id, type, fileName) => {
    try {
      setDocLoader(true);

      const res = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          method: "preview-identity-document",
          documentId: id,
          identityName: type,
          userId: filteruser?.userid,
        }
      );

      if (res?.code === STATUS_CODE.SUCCESS) {

        const downloadUrl = res?.url?.url;

        const link = window.document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName || "file");
        window.document.body.appendChild(link);
        link.click();
        link.remove();

      } else {
        message.error("Something went wrong!! Please try again.");
      }

    } catch (error) {
      console.error("Download error:", error);
      message.error("Download failed. Please try again.");
    } finally {
      setDocLoader(false);
    }
  };

  const cvInfoColumns = [
    {
      title: "File Name",
      dataIndex: "documentName",
      key: "name",
      width: 160,
      render: (name) => (
        <div
          title={name}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </div>
      ),
    },

    {
      title: "File type",
      dataIndex: "filetype",
      key: "filetype",
      width: 130,
      render: (value) => (
        <div
          title={value}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 130,
          }}
        >
          {value || "-"}
        </div>
      ),
    },
    {
      title: "CV type",
      dataIndex: "cvtype",
      key: "cvtype",
      width: 110,
      render: (value) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {value === "long" ? "Long" : value === "short" ? "Short" : "-"}
        </span>
      ),
    },
    {
      title: "Date Added",
      dataIndex: "createdon",
      key: "createdon",
      width: 150,
      render: (date) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {date ? dayjs(date).format("Do MMM YYYY") : "-"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => (
        <>
          <DownloadOutlined
            style={{ cursor: "pointer", marginRight: 12 }}
            onClick={() => handleMenuClick(record?.documentId, "cv", record?.documentName)}
          />
          {/* PERMISSION FIX: delete icon only with delete access */}
          {canDelete &&
            (deletingId === record?.documentId ? (
              <span style={{ fontSize: 18 }}>
                <LoadingOutlined spin />
              </span>
            ) : (
              <DeleteOutline
                style={{ cursor: "pointer" }}
                onClick={() =>
                  deleteIdentityInfo(record?.documentId, "cv")
                }
              />
            ))}
        </>
      ),
    },
  ];

  const handleOpenModal = () => {
    if (!canCreate) return; // PERMISSION FIX
    setIsModalOpen(true);
  };

  const allowedwordExtensions = [".doc", ".docx"];
  const allowedpptExtensions = [".ppt", ".pptx"];

  return (
    <CVContainer>
      <CVHeader>
        <h6>My CV</h6>
        {/* PERMISSION FIX: only users with create access see "+ Add New" */}
        {canCreate && (
          <ButtonFilled
            loading={isDocumentUpload}
            onClick={handleOpenModal}
            style={{ borderRadius: 8 }}
          >
            + Add New
          </ButtonFilled>
        )}
      </CVHeader>



      <TableWrapper>
        <Table
          dataSource={cvList}
          columns={cvInfoColumns}
          rowKey="documentId"
          pagination={false}
          tableLayout="fixed"
          scroll={{ y: 220 }}
          style={{ minWidth: 750 }}   // forces horizontal scroll
        />
      </TableWrapper>

      {canCreate && (
        <Modal
          title="Adding CV"
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null} // custom footer
          bodyStyle={{ padding: 0 }}
        >
          <div style={{ padding: "24px" }}>
            <label style={{ fontWeight: 500 }}>File Type:</label>
            <Select
              value={fileType}
              onChange={(val) => setFileType(val)}
              style={{ width: "100%", marginTop: 4 }}
              options={[
                { label: "Word Document", value: "Word Document" },
                {
                  label: "Power Point Presentation",
                  value: "Power Point Presentation",
                },
              ]}
              placeholder="File Type"
            />

            <div style={{ marginBottom: 16, marginTop: 16 }}>
              <label style={{ fontWeight: 500 }}>CV Type:</label>
              <Radio.Group
                onChange={(e) => setCvType(e.target.value)}
                value={cvType}
                style={{ display: "flex", gap: 20, marginTop: 8 }}
              >
                <Radio value="long">Long Form</Radio>
                <Radio value="short">Short Form</Radio>
              </Radio.Group>
            </div>

            <div style={{ width: "100%", marginTop: 16 }}>
              <Upload
                accept={
                  fileType === "Word Document"
                    ? allowedwordExtensions.join(",")
                    : allowedpptExtensions.join(",")
                }
                beforeUpload={(file) => {
                  const fileExt = file.name
                    .substring(file.name.lastIndexOf("."))
                    .toLowerCase();

                  // check if extension allowed
                  if (
                    !(
                      fileType === "Word Document"
                        ? allowedwordExtensions
                        : allowedpptExtensions
                    ).includes(fileExt)
                  ) {
                    notification.error({
                      message: "Invalid File Type",
                      description: `Only Word (.doc, .docx) and PowerPoint (.ppt, .pptx) files are allowed.`,
                    });
                    return Upload.LIST_IGNORE;
                  }

                  setFileDetails({
                    name: file.name,
                    type: file.type,
                    fileSize: file.size,
                    filevalues: file,
                    documentName: selectedItem?.value,
                  });

                  return false;
                }}
                showUploadList={false}
                style={{ width: "100%" }}
              >
                <ButtonFilled
                  icon={<UploadOutlined />}
                  style={{
                    width: "100%",
                    display: "block",
                    boxSizing: "border-box",
                    margin: 0,
                  }}
                >
                  Select File
                </ButtonFilled>
              </Upload>

              {fileDetails?.name && (
                <p style={{ marginTop: 8 }}>{fileDetails.name}</p>
              )}
            </div>

            {/* Custom footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 24,
                paddingTop: 16,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              <ButtonFilled
                onClick={() => {
                  handleCloseModal();
                  setFileDetails(null); // clear file on modal close
                }}
              >
                Cancel
              </ButtonFilled>
              <ButtonFilled
                type="primary"
                onClick={handleupload}
                disabled={!fileDetails}
              >
                Save
              </ButtonFilled>
            </div>
          </div>
        </Modal>
      )}
    </CVContainer>


  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),


});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyCV);